export var getEmptyOption = function (label) { return ({
    label: "Choose ".concat(label),
    value: null,
}); };
